export default __webpack_public_path__ + "static/meet-the-team-hero-2c640bb9d0f265f65ab2eccb81bb31db.png";